<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-cabinet-filing">
      Spaces
      <template v-slot:buttons>
        <v-btn v-if="!busy && spaces.length"
               color="primary"
               @click.prevent="createSpace"
               class="mr-4">
          New Space
        </v-btn>
        <v-btn :to="{name: 'admin.space_fragments.index'}">
          Fragments
        </v-btn>
      </template>
    </page-title>

    <template v-if="busy">
      <p class="text-center">
        <v-progress-circular indeterminate
                             size="50">
        </v-progress-circular>
      </p>
    </template>
    <template v-else-if="spaces.length === 0">
      <div class="text-center">
        <p>
          You haven't created any spaces yet.
        </p>
        <v-btn color="primary"
               @click.prevent="createSpace">
          Create Space
        </v-btn>
      </div>
    </template>
    <v-card v-else-if="spaces.length > 0">
      <v-simple-table>
        <thead>
        <tr>
          <th>
            Title
          </th>
          <th>
            Status
          </th>
          <th>
            Language
          </th>
          <th>
            Creator
          </th>
          <th>
            Fragment
          </th>
          <th class="text-no-wrap">
            Fragment Position
          </th>
          <th>
            Groups
          </th>
          <th>
            Expires
          </th>
          <th>
            Updated
          </th>
          <th>
            Action
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="space in spaces"
            :key="space.id">
          <td class="text-no-wrap">
            <router-link :to="{name: 'admin.space.edit', params: {spaceID: space.id}}">
              {{ space.title }}
            </router-link>
            <template v-if="space.subtitle">
              <div class="text-caption">
                {{ space.subtitle }}
              </div>
            </template>
          </td>
          <td class="text-no-wrap">
            <v-chip v-if="space.is_expired"
                    color="warning"
                    small
                    label
                    class="d-block text-center font-weight-bold text-uppercase">
              Expired
            </v-chip>
            <v-chip v-else
                    :color="space.is_active ? 'success' : 'warning'"
                    small
                    label
                    class="d-block text-center font-weight-bold text-uppercase">
              {{ space.status }}
            </v-chip>
          </td>
          <td>
            {{ space.locale_name }}
          </td>
          <td class="text-no-wrap">
            {{ space.user?.name }}
          </td>
          <td class="text-no-wrap">
            <template v-if="space.fragment">
              {{ space.fragment.name }}
            </template>
          </td>
          <td class="text-no-wrap">
            <template v-if="space.fragment">
              {{ space.fragment_position }}
            </template>
          </td>
          <td>
            <v-tooltip v-if="space.groups?.length"
                       top>
              <template v-slot:activator="{on, attrs}">
                <div v-bind="attrs"
                     v-on="on">
                  Yes
                </div>
              </template>
              <div class="text-no-wrap">
                <div v-for="group in space.groups"
                     :key="group.id">
                  {{ group.name }}
                </div>
              </div>
            </v-tooltip>
            <template v-else>
              No
            </template>
          </td>
          <td class="text-no-wrap">
            <template v-if="space.expires_at">
              {{ space.expires_at | datetime('YYYY-MM-DD') }}
            </template>
          </td>
          <td class="text-no-wrap">
            {{ space.updated_at | datetime('YYYY-MM-DD') }}
          </td>
          <td class="text-no-wrap">
            <v-btn :href="space.preview_url"
                   target="_blank"
                   x-small>
              Preview
            </v-btn>

            <v-btn @click.prevent="copyURL(space)"
                   x-small>
              Copy
            </v-btn>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
<script>
import spaceService from '../../services/spaceService';
import PageTitle from '../../components/PageTitle.vue';
import clipboardService from '../../../../ml/services/clipboardService';

export default {
  components: {PageTitle},
  data() {
    return {
      busy: false,
      error: null,
      spaces: [],
    }
  },
  computed: {},
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      spaceService.getSpaces()
        .then(data => {
          this.spaces = data;
        })
        .finally(() => {
          this.busy = false;
        })
    },
    createSpace() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.error = null;
      return spaceService.createSpace()
        .then(space => {
          this.$router.push({name: 'admin.space.edit', params: {spaceID: space.id}});
        })
        .catch(err => {
          this.error = err;
        })
        .finally(() => {
          this.busy = false;
        })
    },
    copyURL(space) { // MLD-5686
      clipboardService.copy(space.view_url, false)
        .then(() => {
          this.$toast.success('Space URL copied to your clipboard.');
        })
    },
  }
}
</script>
